export default __webpack_public_path__ + "static/media/Zen.aa5c4cf1.png";